import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';
import {createAnatomy} from '@zag-js/anatomy';

export const textAnatomy = createAnatomy(`display`, [`root`]).build();
export const vars = defineCssVars(`display`, [`font-size`, `line-height`, `font-weight`]);

export const displayTheme = defineStyleConfig({
  baseStyle: {
    [vars[`font-weight`].variable]: `fontWeights.display.md`,
    [vars[`font-size`].variable]: `fontSizes.display.md`,
    [vars[`line-height`].variable]: `lineHeights.display.md`,
    fontFamily: `inter`,
    fontWeight: vars[`font-weight`].reference,
    fontSize: vars[`font-size`].reference,
    lineHeight: vars[`line-height`].reference,
  },
  sizes: {
    lg: {
      [vars[`font-weight`].variable]: `fontWeights.display.lg`,
      [vars[`font-size`].variable]: `fontSizes.display.lg`,
      [vars[`line-height`].variable]: `lineHeights.display.lg`,
    },
    md: {
      [vars[`font-weight`].variable]: `fontWeights.display.md`,
      [vars[`font-size`].variable]: `fontSizes.display.md`,
      [vars[`line-height`].variable]: `lineHeights.display.md`,
      fontSize: vars[`font-size`].reference,
    },
    sm: {
      [vars[`font-weight`].variable]: `fontWeights.display.sm`,
      [vars[`font-size`].variable]: `fontSizes.display.sm`,
      [vars[`line-height`].variable]: `lineHeights.display.sm`,
    },
  },
  defaultProps: {
    size: `md`,
  },
});
